import { render } from "./StepperStatic.vue?vue&type=template&id=9036f232&scoped=true"
import script from "./StepperStatic.vue?vue&type=script&lang=js"
export * from "./StepperStatic.vue?vue&type=script&lang=js"

import "./StepperStatic.vue?vue&type=style&index=0&id=9036f232&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9036f232"]])

export default __exports__